import { Controller } from "@hotwired/stimulus"

// Handles wizard option buttons in the AI chat.
// Single-select: click a button → fills input → auto-submits
// Multi-select: toggle buttons on/off → click "Confirm" to submit selected values
export default class extends Controller {
  static targets = ["option", "confirm"]
  static values = { mode: { type: String, default: "single" } }

  select(event) {
    const btn = event.currentTarget
    const value = btn.dataset.value

    if (this.modeValue === "single") {
      this._submit(value)
    } else if (this.modeValue === "single-confirm") {
      // Deselect all others, then select this one
      this.optionTargets.forEach(opt => {
        opt.classList.remove("ring-2", "ring-purple-500", "bg-purple-50", "text-purple-700", "border-purple-300")
      })
      btn.classList.add("ring-2", "ring-purple-500", "bg-purple-50", "text-purple-700", "border-purple-300")
    } else {
      btn.classList.toggle("ring-2")
      btn.classList.toggle("ring-purple-500")
      btn.classList.toggle("bg-purple-50")
      btn.classList.toggle("text-purple-700")
      btn.classList.toggle("border-purple-300")
    }
  }

  confirm() {
    const selected = this.optionTargets
      .filter(btn => btn.classList.contains("ring-2"))
      .map(btn => btn.dataset.value)

    if (selected.length === 0) return

    // Also grab the breakdown input if present
    const breakdownInput = this.element.querySelector("[data-wizard-breakdown]")
    let value = selected.join(", ")
    if (breakdownInput) {
      const breakdown = breakdownInput.value.trim()
      value += breakdown ? `, breakdown: ${breakdown}` : ", none"
    }

    this._submit(value)
  }

  useTemplate(event) {
    const template = event.currentTarget.dataset.template
    this._submit(template)
  }

  _submit(value) {
    const input = document.getElementById("content")
    if (!input) return

    // For multi-line values (layout templates), use a hidden textarea
    // since text_field_tag strips newlines
    if (value.includes("\n")) {
      const form = input.closest("form")
      if (!form) return
      const hidden = document.createElement("textarea")
      hidden.name = "content"
      hidden.value = value
      hidden.style.display = "none"
      form.appendChild(hidden)
      input.removeAttribute("name")
      input.value = value.split("\n").join(", ")
      form.requestSubmit()
      // Restore after submit
      setTimeout(() => {
        hidden.remove()
        input.name = "content"
        input.value = ""
      }, 100)
    } else {
      input.value = value
      const form = input.closest("form")
      if (form) form.requestSubmit()
    }
  }
}
